module.exports = __webpack_public_path__ + "3446a6f3052f40914439925ccfc007fe.png";